// Market Intelligence hub JS (minimal, dependency-free)
(() => {
  const d = document;

  // Ticker fetch
  const tickerRoot = d.querySelector('[data-mi-ticker]');
  if (tickerRoot) {
    const endpoint = tickerRoot.getAttribute('data-endpoint');
    if (endpoint) {
      fetch(endpoint, { credentials: 'omit', cache: 'no-store' })
        .then(r => r.ok ? r.json() : [])
        .then(rows => {
          if (!Array.isArray(rows)) return;
          rows.forEach(row => {
            const el = d.querySelector(`.mi-ticker-item[data-symbol="${row.symbol}"]`);
            if (!el) return;
            const p = el.querySelector('[data-field="price"]');
            const c = el.querySelector('[data-field="change"]');
            if (p) p.textContent = (row.price ?? '—');
            if (c) {
              const sign = (row.changePct ?? 0) >= 0 ? '+' : '';
              c.textContent = `${sign}${(row.changePct ?? 0).toFixed(2)}%`;
              c.classList.toggle('mi-up', (row.changePct ?? 0) > 0);
              c.classList.toggle('mi-down', (row.changePct ?? 0) < 0);
            }
          });
        })
        .catch(() => {/* graceful no-op */});
    }
  }

  // Mark active chips when on a tagged URL
  const path = location.pathname;
  const taggedIdx = path.indexOf('/tagged/');
  if (taggedIdx !== -1) {
    const tagsPart = path.slice(taggedIdx + 8); // after '/tagged/'
    const active = tagsPart.split('+').map(s => s.replace(/\/+$/,'').toLowerCase());
    d.querySelectorAll('.mi-chip').forEach(a => {
      const href = a.getAttribute('href') || '';
      const tag = href.split('/tagged/')[1];
      if (!tag) return;
      if (active.includes(tag.toLowerCase())) a.classList.add('is-active');
    });
  }
})();